<template>
    <Article>
        <template #header>
            <h2>Whats in a Name? From Galahad to MARS Task Force</h2>
        </template>
        <template #content>
            <div>
                <h3 style="text-align:center"><strong>Galahad</strong></h3>
                Quite simply, &quot;Galahad&quot; was simply a code name for the 5307
                <sup>th</sup>
                Composite Unit (Provisional). Galahad was used during the planning stages, and well
                after the organization was on the move to engage the Japanese forces.&nbsp; Since
                the unit had no designation in the early stages, it was simpler to refer to it as
                the Galahad Unit. As the 5307
                <sup>th</sup>
                began the long march in February 1944, the code name was still used in an effort to
                keep the Japanese in the dark as to the unit it was facing.&nbsp; How was the name
                picked? No one knows.
                <h3 style="text-align:center"><strong>New Galahad</strong></h3>
                Technically no such name was ever used officially.&nbsp; When the 475
                <sup>th</sup>
                Infantry Regiment took over, the Personnel Sergeant, in his words, &quot;gathered
                every piece of paper I could find with a name on it, and published an order awarding
                the Combat Infantryman Badge to every soldier I could identify.&quot; &nbsp;Those
                identified as original members of the 5307
                <sup>th</sup>
                were awarded the CIB effective 20 Feb 44, and those who had been assigned to the
                unit as replacements on 1 June 44 and later were awarded the CIB effective 1 June
                44.&nbsp; They were identified by an asterisk on the order.&nbsp; The effective
                dates were important, as the enlisted men who received the CIB were entitled to an
                additional $10.00 per month.
                <h3 style="text-align:center"><strong>MARS Task Force</strong></h3>
                The actual name of this unit was the 5332
                <sup>nd</sup>
                Brigade (Provisional). How did it get the name MARS Task Force? Again, no one is
                sure.&nbsp; In a conversation with Woody Woodruff who served with one of the
                artillery battalions of the brigade, he stated that one of the more popular theories
                was that it was named for the first commander who was General Arms. Obviously, if
                this was the case, the letters of his name were rearranged.
            </div>
        </template>
    </Article>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import Article from '@/components/Article/Article.vue';

export default defineComponent({
    name: 'WhatsInAName',
    components: { Article }
});
</script>
